import { defineComponent as _defineComponent } from 'vue'
import { loadFullPlankManageData } from '@/apis/baseMaterial'
import { fetchSaveBaseMaterial } from '@/apis/materialList'
import {
  checkUserPermissionWithToast,
  checkUserPermissions,
  checkUserPermissionsWithDetailToast,
} from '@/auth/user_function'
import addSurplus from '@/components/addSurplusTemp'
import drawSupplus from '@/components/draw/drawSupplus.vue'
import gBaseModal from '@/components/g-base-modal.vue'
import GPaidFeature from '@/components/g-paid-feature.vue'
import NewContent from '@/components/newContent.vue'
import pageTable from '@/components/page-table'
import { USER_PERMISSION_KEY } from '@/data/auth'
import { translateLang as translateU } from '@/data/i18n/translateLang'
import store from '@/store'
// 排版任务全局 store：侧栏角标、任务列表、创建飞行动效共用
import { createPendingPaibanTask } from '@/store/modules/paibanTaskStore'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import {
  isBrandIdentityCompatible,
  isBrandRecord,
} from '@/util/brandPlankIdentity'
import { EventBusKey } from '@/util/bus'
import EventBus from '@/util/bus'
import { matchMixPaibanPlan } from '@/util/common'
import { matchHighlightBoardName, translate } from '@/util/commonFun'
import {
  buryPointApi,
  genUniId,
  verifyInputNumber,
} from '@/util/commonFuncs.js'
import { saveDataJsonToOss } from '@/util/saveFile'
import MDeepBadgeAurora from '@/views/newPaiban/component/moreAlignedPlan/iconComponents/m-deep-badge-aurora.vue'
import { cloneDeep } from 'lodash'
import Sortable from 'sortablejs'
import Vue from 'vue'
import {
  computed,
  getCurrentInstance,
  nextTick,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
} from 'vue'

import sendModal from '../../newPaiban/component/m-sendModal.vue'
import { isBrandPart } from '../../newPaiban/util/layoutDataDeal'
import { rules } from '../config/roules'
import { surPlusConfig } from '../config/tableConfig'

interface PropsType {
  isSurplusCutting?: boolean
  showProLineDialog: boolean
  isConfirmLoading?: boolean
  isFromDrawAllParts?: boolean
  clickFlag?: boolean
  isLessReverse?: boolean
  selectedPaibanWay?: string
  isSpecialShape?: boolean
  filterPlankList?: Array<any>
  paibanMessage: Record<string, any>
  hasSelectSpecialShapeSurplus?: boolean
  isCustomSurplusEdge: boolean
  surplusInfo?: any
  hasBrandPart?: boolean
  /** 补件库/待排版库参与排版的品牌小板，用于自定义大板顺序中品牌大板的匹配展示 */
  extraBrandParts?: Array<any>
}
// 以下数据都是异形嵌套相关
type RadioEventTarget = EventTarget & { value: string }
enum nestEnum {
  PRIMARY = 1,
  SENIOR = 2,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'paibanSetting',
  props: {
    isSurplusCutting: { type: Boolean },
    showProLineDialog: { type: Boolean, default: false },
    isConfirmLoading: { type: Boolean },
    isFromDrawAllParts: { type: Boolean, default: false },
    clickFlag: { type: Boolean, default: false },
    isLessReverse: { type: Boolean },
    selectedPaibanWay: null,
    isSpecialShape: { type: Boolean },
    filterPlankList: null,
    paibanMessage: null,
    hasSelectSpecialShapeSurplus: { type: Boolean },
    isCustomSurplusEdge: { type: Boolean, default: false },
    surplusInfo: null,
    hasBrandPart: { type: Boolean, default: false },
    extraBrandParts: { default: () => [] }
  },
  emits: [
  'onConfirm',
  'onSelectProLine',
  'onCancel',
  'onSendToFactory',
  'onConfirmSend',
  'onCloseSend',
  'onFetchProLineList',
  'onSelectLine',
  'getInitData',
  'getFinalData',
  'getInitTableData',
  'getFinalTableData',
  'getInitSurplusSelectData',
  'getFinalSurplusSelectData',
  'onSelectStandard',
  'onShowPartDetail',
],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { isSurplusCutting?: boolean, showProLineDialog: boolean, isConfirmLoading?: boolean, isFromDrawAllParts: boolean, clickFlag: boolean, isLessReverse?: boolean, selectedPaibanWay?: string, isSpecialShape?: boolean, filterPlankList?: Array<any>, paibanMessage: Record<string, any>, hasSelectSpecialShapeSurplus?: boolean, isCustomSurplusEdge: boolean, surplusInfo?: any, hasBrandPart: boolean, extraBrandParts: Array<any> }

const { proxy } = getCurrentInstance()!



//定义偏好设置中保存的表头数据
const saveTableData = ref([])
const isShowExPaibanConfirm = ref(false)
const isShow = ref(props.showProLineDialog)
const surplusSelect = ref<any[]>([])
const proLineList = ref<any[]>([])
const isLoading = ref<boolean>(false)

const tableLoading = ref<boolean>(false)
const surplusData = ref<any[]>([])
const oldSurplusData = ref<any[]>([])
let deleteIdList = ref([]) as any
//默认异形嵌套方式为普通嵌套
const radioVal = ref<string>('PRIMARY')
// 是否拥有高级异形嵌套权限；无权限时高级嵌套置灰并自动回退到普通嵌套
const hasAdvancedNestPermission = computed(
  () =>
    checkUserPermissions([USER_PERMISSION_KEY.ADVANCED_IRREGULAR_NESTING]) ===
    true
)

const hasDeepSearchPermission = computed(() => {
  return (
    checkUserPermissions([USER_PERMISSION_KEY.DEEP_SEARCH]) === true &&
    Boolean(window.webToQt?.expressVip)
  )
  const ggver = sessionStorage.getItem('guigui_version') ?? ''

  const GGV = Number(
    (window.webToQt?.ggVersion ?? ggver).split('-')[0].split('.').join('')
  )
  return (
    (window.webToQt &&
      GGV >= 5003 &&
      checkUserPermissions([USER_PERMISSION_KEY.DEEP_SEARCH]) === true) ||
    Boolean(window.webToQt?.expressVip)
  )
})

// 遮罩层位置
const dialogStyle = reactive({
  top: '130px',
  right: '-240px',
})
const pagination = reactive({
  total: 1,
  style: {
    marginTop: '5px',
  },
  small: true,
  background: true,
  pageSizes: [3, 6, 15, 30],
  layout: 'sizes, prev, pager, next',
})
const page = reactive({
  limit: 3,
  page: 1,
})

const surplusVisible = ref(false)
// 记录开始排版弹窗里需要记住的字段
const state = reactive({
  isCreateTask: false,
  layoutMethod: '',
  paibanWay: '',
  process_line_id: '',
  surplusTailorWay: 'maxRect',
  surplusAutoTailor: true,
  // 记录是否少翻版
  isLessReverse: false,
  // 余料不排指定小板
  isSurNotLayoutMat: true,
  isSurNotLayout: false,
  plankNames: [],
  // 记录是否支持异形
  isSpecialShape: false,
  // 默认计算异形状方式为普通嵌套
  nesting_version: nestEnum.PRIMARY,
  shortSideRect: 270,
  longSideRect: 300,
  // 设置不同厚度板件最小裁剪尺寸
  isSetCustomRect: false,
  // 自定义不同厚度板件最小裁剪尺寸
  customRectTemplate: [
    // 默认保留一条数据，无法删除
    {
      shortSideRect: 250,
      longSideRect: 300,
      // 大板厚度，默认为空
      thickRect: null,
    },
  ] as any[],
  isSurplusNoRoll: false,
  standardPlankList: [] as any,
  selectStandardPlank: '',
  // 自定义大板排版顺序
  customPlankOrder: false,
  plankOrderList: [] as any,
  plankOrderColumns: [
    {
      label: '排版顺序',
      prop: 'plankOrder',
      width: '80',
      align: 'center',
      transKey: 'materialPage.paibanSetting.plankOrder',
    },
    {
      label: '品牌',
      prop: 'brandName',
      width: '100',
      transKey: 'basePlankManager.brand',
    },
    {
      label: '供应商',
      prop: 'supplierName',
      width: '100',
      transKey: 'basePlankManager.supplier',
    },
    {
      label: '板材类型',
      prop: 'plankType',
      width: '100',
      transKey: 'materialPage.paibanSetting.plankType',
    },
    {
      label: '板材材质',
      prop: 'matCode',
      width: '110',
      transKey: 'common.plankMatCode',
    },
    {
      label: '板材尺寸',
      prop: 'plankSize',
      width: '120',
      transKey: 'materialPage.paibanSetting.plankSize',
    },
    {
      label: '修边值',
      prop: 'plankEdgeOff',
      width: '100',
      transKey: 'materialPage.paibanSetting.plankEdgeOff',
    },
    {
      label: '板材颜色',
      prop: 'texture',
      width: '110',
      transKey: 'common.plankColor',
    },
    {
      label: '板材厚度',
      prop: 'thick',
      width: '110',
      transKey: 'common.plankThick',
    },
    {
      label: '高光板',
      prop: 'isHighPlank',
      width: '100',
      transKey: 'common.heighGlossPlank',
    },
    {
      label: '下料数量',
      prop: 'amount',
      width: '100',
      transKey: 'materialPage.paibanSetting.amount',
    },
    {
      label: '操作',
      prop: 'operate',
      transKey: 'common.operation',
      width: '120',
    },
  ],
  // 大板数量不够或超尺
  isEnoughOrOversize: false,
  // 原片管理数据
  materialRes: {} as any,
  isPreLayout: false,
  // isUseSeniorNest:false
  isCombineToLShape: false,
  // 排版堆叠方式
  stacking_method: 'short',
})

const isNoCreateTask = computed(() => {
  return (
    (props.hasSelectSpecialShapeSurplus &&
      !selectedPaibanWay.value.includes('v2')) ||
    state.isPreLayout
  )
})

const customPlankOrderColumns = computed(() => {
  if (props.hasBrandPart) return state.plankOrderColumns
  return state.plankOrderColumns.filter(
    (item) => !['brandName', 'supplierName'].includes(item.prop)
  )
})
const selectedBrandPartsForCustomOrder = computed(() => {
  const listPickedParts = (props.filterPlankList || [])
    .flatMap((item) => item.parts || [])
    .filter((part) => part.isSelected && isBrandPart(part))
  const extraParts = (props.extraBrandParts || []).filter((part) =>
    isBrandPart(part)
  )
  return [...listPickedParts, ...extraParts]
})
const hasMissingBrandPlankInCustomOrder = computed(() => {
  if (!state.customPlankOrder || !props.hasBrandPart) return false
  const availableBrandPlankList = state.plankOrderList.filter(
    (item: any) =>
      item.plankType != '标准大板' &&
      item.amount != 0 &&
      item.brandName &&
      item.supplierName
  )
  return selectedBrandPartsForCustomOrder.value.some((part: any) => {
    const mixPaibanPlan =
      store.state.materialListStore!.selectedMixPaibanPlans.find((plan) =>
        matchMixPaibanPlan(plan, part)
      )
    return !availableBrandPlankList.some(
      (plate: any) =>
        part.matCode == plate.matCode &&
        part.thick == plate.thick &&
        (part.texture == plate.texture ||
          mixPaibanPlan?.allColors.includes(plate.texture)) &&
        part.brandName == plate.brandName &&
        part.supplierName == plate.supplierName
    )
  })
})
// 排版方案
const paibanWayList = ref<any[]>([
  {
    title: 'common.sawArrange',
    interface: 'paiban',
    desc: 'materialPage.paibanSetting.suitEquipmentSpecial',
  },
  {
    title: 'common.directArrange',
    interface: 'paiban_v2',
    desc: 'materialPage.paibanSetting.suitEquipmentNormal',
  },
  // {
  //   title: 'AI智能直切排版(试用,优化时间较长)',
  //   interface: 'blue_ai/paiban',
  //   desc: '常规雕刻机',
  // },
])
// 当前选中的排版方案
const selectedPaibanWay = ref<string>('paiban_v2')
const isShowPaibanWayToast = computed(
  () => props.isCustomSurplusEdge && selectedPaibanWay.value == 'paiban_v2'
)

const isTaskLoading = ref<boolean>(false)
// 发送车间弹窗
const sendToFactoryDialog = ref<boolean>(false)
// 设备是否玻璃切割机
const isGlassEquip = ref<boolean>(false)
// 设备是否为电子据
const isElectron = ref<boolean>(false)
// 当前生产线
const selectLine = ref()
// 是否显示高级设置
const isShowAdvancedSetting = ref<boolean>(false)
const isSlideAnimating = ref(false)
const SLIDE_DURATION = 300
const advancedSettingTab = ref<'advanced' | 'display'>('advanced')
// 高级功能
const advancedFeature = reactive({
  // 余料切割智能提速
  surplus_cut_smart_speed_up: false,
})
// 功能显示：仅控制主设置入口是否展示
const featureDisplay = reactive({
  preLayout: true,
  paibanWay: true,
  isSurNotLayoutMat: true,
  stacking_method: true,
  specialShape: true,
  standardPlank: true,
  autoSelectBigPlank: true,
  only_layout_too_big: true,
  customPlankOrder: true,
  surplusAutoTailor: true,
  combineToLShape: true,
})
const isWebToQt = computed(() => {
  return Boolean((window as any).webToQt)
})
// 是否执行关闭时的操作
watch(
  () => props.showProLineDialog,
  (val) => {
    isShow.value = val
  }
)
watch(
  () => isShow.value,
  (val) => {
    if (!val) {
      isShowAdvancedSetting.value = false
      isSlideAnimating.value = false
      if (!props.isFromDrawAllParts) {
        emits('onCancel', true)
      }
    } else {
      if (props.hasBrandPart) {
        state.customPlankOrder = true
      }
      if (props.clickFlag) {
        state.isLessReverse = Boolean(props.isLessReverse)
        state.isSpecialShape = Boolean(props.isSpecialShape)
        selectedPaibanWay.value = props.selectedPaibanWay ?? ''
      }
      // 开启弹窗，传递第一次数据出去，作为数据是否改变的对比
      emits('getInitData', JSON.parse(JSON.stringify(state)))
      if (state.surplusAutoTailor) {
        emits('getInitTableData', JSON.parse(JSON.stringify(surplusData.value)))
        // 获取选择的数据项，查看数据是否改变
        emits(
          'getInitSurplusSelectData',
          JSON.parse(JSON.stringify(surplusSelect.value))
        )
      }
      if (
        props.filterPlankList?.length &&
        !Object.keys(props.paibanMessage).length
      ) {
        state.plankOrderList = []
        let pickedList = [] as any
        let notPickedList = [] as any
        const filterPlankList = props.filterPlankList?.filter((item) =>
          item.parts.some((part: any) => part.isSelected)
        )
        if (state.selectStandardPlank) {
          const standardPlank = JSON.parse(state.selectStandardPlank)
          Vue.set(state.plankOrderList, 0, {
            plankOrder: 1,
            plankType: '标准大板',
            matCode: '-',
            plankSize: `${standardPlank.plankWidth}x${standardPlank.plankHeight}`,
            plankEdgeOff: standardPlank.plankEdgeOff,
            texture: '-',
            thick: '-',
            isHighPlank: '-',
            amount: 9999,
            id: genUniId(),
          })
          const specialPlankInfo = state.materialRes.specialPlankInfo || []
          if (specialPlankInfo.length) {
            // 重新聚类特殊大板
            const specialPlank = {} as any
            specialPlankInfo.forEach((plank: any) => {
              const { color, thick, matCode } = plank
              const specialHighPlank = matCode.includes('高光_')
              const symbol = `${matCode.replace(
                '高光_',
                ''
              )}:${thick}:${color}:${specialHighPlank}`
              plank.symbol = symbol
              if (Reflect.has(specialPlank, symbol)) {
                specialPlank[symbol].push(plank)
              } else {
                specialPlank[symbol] = [plank]
              }
            })

            filterPlankList?.forEach((item) => {
              const { texture, matCode, thick, high_plank } = item
              const selectedItemParts = (item.parts || []).filter(
                (part: any) => part.isSelected
              )
              // 补件库/待排版库的品牌小板也参与该材质分组下品牌大板的匹配
              const normalizeMatCode = (code: string) =>
                (code || '').replace('高光_', '')
              const extraGroupBrandParts = (props.extraBrandParts || []).filter(
                (part: any) =>
                  isBrandPart(part) &&
                  normalizeMatCode(part.matCode) == normalizeMatCode(matCode) &&
                  part.thick == thick &&
                  part.texture == texture
              )
              const selectedBrandParts = [
                ...selectedItemParts.filter((part: any) => isBrandPart(part)),
                ...extraGroupBrandParts,
              ]
              const hasSelectedNonBrandPart = selectedItemParts.some(
                (part: any) => !isBrandPart(part)
              )
              const canUseSpecialPlank = (specialItem: any) => {
                const isBrandPlank = isBrandRecord(specialItem)
                if (isBrandPlank) {
                  return selectedBrandParts.some((part: any) =>
                    isBrandIdentityCompatible(part, specialItem)
                  )
                }
                return hasSelectedNonBrandPart || !selectedBrandParts.length
              }
              // 判断当前小板是否符合选择的混排方案
              const mixPaibanPlan =
                store.state.materialListStore!.selectedMixPaibanPlans.find(
                  (plan) => matchMixPaibanPlan(plan, { matCode, texture })
                )
              // 如果开启了混排方案，则需要取到混排方案的目标颜色
              const targetTexture = mixPaibanPlan?.targetTexture ?? texture

              // 获取所有需要生成symbol的颜色列表
              const colorList = mixPaibanPlan?.allColors || [texture]

              //  增加匹配规则，需要加入定义颜色的规则
              // 定义symbol模板：包含颜色的位置使用函数，不包含颜色的位置使用字符串
              const symbolTemplates: Array<
                ((color: string) => string) | string
              > = [
                item.symbol, // 位置0: part.symbol
                (color: string) => `${matCode}:${thick}:${color}:${high_plank}`, // 位置1: 包含颜色
                (color: string) => `${matCode}::${color}:${high_plank}`, // 位置2: 包含颜色
                `${matCode}:${thick}::${high_plank}`, // 位置3: 不包含颜色
                (color: string) => `:${thick}:${color}:${high_plank}`, // 位置4: 包含颜色
                `${matCode}:::${high_plank}`, // 位置5: 不包含颜色
                (color: string) => `::${color}:${high_plank}`, // 位置6: 包含颜色
                `:${thick}::${high_plank}`, // 位置7: 不包含颜色
                `:::${high_plank}`, // 位置8: 不包含颜色
              ]

              // 按照symbolArr的顺序生成，包含颜色的位置为所有颜色生成symbol
              const symbolArr = symbolTemplates.flatMap((template) =>
                typeof template === 'function'
                  ? colorList.map(template)
                  : template
              )

              for (let i = 0; i < symbolArr.length; i++) {
                if (specialPlank[symbolArr[i]]) {
                  specialPlank[symbolArr[i]].forEach((specialItem: any) => {
                    if (!canUseSpecialPlank(specialItem)) return
                    const matCodeTemp =
                      specialItem.matCode.replace('高光_', '') || matCode
                    const textureTemp = specialItem.color || targetTexture
                    if (specialItem.isPicked) {
                      pickedList.push({
                        plankType: '特殊大板',
                        brandName: specialItem.brand_name || '',
                        supplierName: specialItem.supplier_name || '',
                        matCode: matCodeTemp,
                        plankSize: `${specialItem.width}x${specialItem.height}`,
                        plankEdgeOff: specialItem?.trim_edge,
                        texture: textureTemp,
                        thick: specialItem.thick || thick,
                        isHighPlank: high_plank ? '高光板' : '非高光板',
                        amount: 0,
                        id: genUniId(),
                        // 每添加一块特殊大板，需要完善symbol
                        symbol: `${matCodeTemp}:${thick}:${textureTemp}:${specialItem.symbol
                          .split(':')
                          .pop()}`,
                        colorId: specialItem.color_id || '',
                      })
                    }
                    if (!specialItem.isPicked) {
                      notPickedList.push({
                        plankType: '特殊大板',
                        brandName: specialItem.brand_name || '',
                        supplierName: specialItem.supplier_name || '',
                        matCode: matCodeTemp,
                        plankSize: `${specialItem.width}x${specialItem.height}`,
                        plankEdgeOff: specialItem?.trim_edge,
                        texture: textureTemp,
                        thick: specialItem.thick || thick,
                        isHighPlank: high_plank ? '高光板' : '非高光板',
                        amount: 0,
                        id: genUniId(),
                        // 每添加一块特殊大板，需要完善symbol
                        symbol: `${matCodeTemp}:${thick}:${textureTemp}:${specialItem.symbol
                          .split(':')
                          .pop()}`,
                        colorId: specialItem.color_id || '',
                      })
                    }
                  })
                }
              }
            })
            // 根据宽高最长的重新排序
            pickedList = pickedList.sort((a: any, b: any) => {
              const aMax = Math.max(
                a.plankSize.split('x')[0],
                a.plankSize.split('x')[1]
              )
              const bMax = Math.max(
                b.plankSize.split('x')[0],
                b.plankSize.split('x')[1]
              )
              return aMax - bMax
            })
            notPickedList = notPickedList.sort((a: any, b: any) => {
              const aMax = Math.max(
                a.plankSize.split('x')[0],
                a.plankSize.split('x')[1]
              )
              const bMax = Math.max(
                b.plankSize.split('x')[0],
                b.plankSize.split('x')[1]
              )
              return aMax - bMax
            })
            const allList = pickedList.concat(notPickedList)
            allList.forEach((item: any) => {
              if (
                state.plankOrderList.findIndex(
                  (plankOrderItem: any) =>
                    item.brandName == plankOrderItem.brandName &&
                    item.supplierName == plankOrderItem.supplierName &&
                    item.matCode == plankOrderItem.matCode &&
                    item.plankSize == plankOrderItem.plankSize &&
                    item.plankEdgeOff == plankOrderItem.plankEdgeOff &&
                    item.texture == plankOrderItem.texture &&
                    item.thick == plankOrderItem.thick &&
                    item.isHighPlank == plankOrderItem.isHighPlank
                ) === -1
              ) {
                state.plankOrderList.push(item)
              }
            })
            state.plankOrderList = state.plankOrderList.map(
              (item: any, index: number) => ({
                ...item,
                plankOrder: index + 1,
              })
            )
          }
        }
      }
    }
  }
)

watch(
  () => props.hasBrandPart,
  (val) => {
    if (val) {
      state.customPlankOrder = true
    }
  },
  { immediate: true }
)

watch(
  () => state.customPlankOrder,
  (newV) => {
    if (newV) {
      nextTick(() => {
        handleDropPlankOrder()
        handleTranslateCustomTable()
      })
    }
  },
  { immediate: true }
)

watch(
  () => props.paibanMessage,
  (newV) => {
    if (Object.keys(newV).length) {
      let plateObj: any = {}
      state.isEnoughOrOversize = true
      Object.keys(newV).forEach((key: string) => {
        newV[key].message.forEach((message: any) => {
          if (!plateObj.hasOwnProperty(message.plate.order)) {
            plateObj[message.plate.order] = {
              ...message.plate,
              isEnoughOrOversize: message.message,
            }
          } else {
            plateObj[message.plate.order].isEnoughOrOversize += message.message
          }
        })
      })
      state.plankOrderList = state.plankOrderList.map((item: any) => ({
        ...item,
        isEnoughOrOversize: '',
      }))

      Object.keys(plateObj).forEach((key: string) => {
        state.plankOrderList.forEach((item: any) => {
          if (key == item.plankOrder) {
            if (
              plateObj[key].isEnoughOrOversize.includes('数量不够') &&
              plateObj[key].isEnoughOrOversize.includes('超尺')
            ) {
              // '存在小板超尺且大板用量不足无法排版'
              item.isEnoughOrOversize = translateLang(
                'materialPage.paibanSetting.numAndOverSizeTip'
              )
            } else if (plateObj[key].isEnoughOrOversize.includes('数量不够')) {
              // '大板用量不足无法排版'
              item.isEnoughOrOversize = translateLang(
                'materialPage.paibanSetting.numErrorTip'
              )
            } else if (plateObj[key].isEnoughOrOversize.includes('超尺')) {
              // '存在小板超尺无法排版'
              item.isEnoughOrOversize = translateLang(
                'materialPage.paibanSetting.overSizeTip'
              )
            } else {
              item.isEnoughOrOversize = ''
            }
          }
        })
      })
    } else {
      state.isEnoughOrOversize = false
      state.plankOrderList = state.plankOrderList.map((item: any) => ({
        ...item,
        amount: 9999,
        isEnoughOrOversize: '',
      }))
    }
  }
)
watch(
  () => state.process_line_id,
  () => {
    store.commit('setSettingId', state.process_line_id)
  }
)

function handleAdvancedSetting() {
  isSlideAnimating.value = true
  isShowAdvancedSetting.value = !isShowAdvancedSetting.value
  if (isShowAdvancedSetting.value) {
    buryPointApi('material', 'advanced_setting_open')
  }
  setTimeout(() => {
    isSlideAnimating.value = false
  }, SLIDE_DURATION)
}

// 判断是否选择模板
function judgeSelectTemplate() {
  if (state.surplusAutoTailor && state.surplusTailorWay == 'commonRect') {
    if (!surplusSelect.value.length) {
      return Vue.prototype.$message.error(
        translateLang('materialPage.paibanSetting.templateErr')
      )
    }
    store.commit('setSurplusCommonSize', surplusSelect.value)
    buryPointApi('material', 'sup_common')
  }
  return true
}
function judgeMaxRectTemplate() {
  if (state.surplusAutoTailor && state.surplusTailorWay == 'maxRect') {
    if (!state.isSetCustomRect) return true
    // 检查customRectTemplate中是否存在空数据或者重复厚度数据 非法情况
    const checkThickList = [] as any
    for (let item of state.customRectTemplate) {
      if (
        item.shortSideRect == null ||
        item.longSideRect == null ||
        item.thickRect == null
      ) {
        checkThickList.push(item.thickRect)
        Vue.prototype.$message.error(
          translateUniform('“设置不同厚度板件最小裁剪尺寸”模板数据不能为空！')
        )
        return false
      }
      if (checkThickList.indexOf(item.thickRect) !== -1) {
        Vue.prototype.$message.error(
          translateUniform(
            '“设置不同厚度板件最小裁剪尺寸”模板数据中存在重复的厚度数据！'
          )
        )
        return false
      }
      checkThickList.push(item.thickRect)
    }
  }
  return true
}

function handleConfirm(event: MouseEvent, isCreateTask = false) {
  if (
    checkUserPermissions([USER_PERMISSION_KEY.ADVANCED_IRREGULAR_NESTING]) !==
      true &&
    radioVal.value === 'SENIOR' &&
    state.isSpecialShape
  ) {
    isShowExPaibanConfirm.value = true
  } else {
    handleConfirmPaiban(event, isCreateTask)
  }
}

function handleCancelConfirm() {
  isShowExPaibanConfirm.value = false
}

/**
 * 「创建排版任务」按钮：校验通过后写入全局任务列表、触发侧栏角标 +1、播放飞行动效
 * 与「确认」按钮（handleConfirm）分离，仅本入口产生新任务记录
 */
function handleConfirmCreateTask(event: MouseEvent) {
  const hasPermission = checkUserPermissionWithToast(
    USER_PERMISSION_KEY.CREATE_PAIBAN_TASK,
    translateLang('该功能为付费功能，请联系销售开通后使用~')
  )
  if (!hasPermission) {
    return
  }
  isTaskLoading.value = true
  handleConfirm(event, true)
}

/** 等待排版任务卡片飞行动效结束，以便弹窗在动效完成后再关闭 */
function waitPaibanTaskFlyEnd(): Promise<void> {
  return new Promise((resolve) => {
    EventBus.$once(EventBusKey.PAIBAN_TASK_FLY_END, resolve)
  })
}

function createPaibanTask(payload: any): Promise<string> {
  const { data, prePaibanData, paibanWay, preLayoutData, order_nos } = payload

  return new Promise((resolve) => {
    saveDataJsonToOss(
      {
        prePaibanData,
        paibanWay,
        preLayoutData,
        paibanSetting: {
          ...state,
          surplusCommonSize: store.state.surplusCommonSize,
        },
        ncSetting: store.state.ncSetting,
      },
      async (url: string) => {
        const dataFileUrl = url
        const paibanPayload = {
          plank_url: dataFileUrl,
          production_line_id: Number(state.process_line_id),
          order_nos: order_nos,
          pending_data_list: data,
          production_from: window.sessionStorage.getItem('thinkerx_material')
            ? 'guimen'
            : '',
        }

        const createRes = await createPendingPaibanTask(paibanPayload)
        if (createRes && createRes.task_batch) {
          // DOM 更新后再取按钮/侧栏坐标，保证 getBoundingClientRect 准确
          await nextTick()
          EventBus.$emit(EventBusKey.PAIBAN_TASK_FLY, {
            fromSelector: '#paiban_setting_create_task_btn',
            taskBatch: '1234567890', // TODO: 后续需要修改为实际的批次号
            statusText: '等待中',
          })
          await waitPaibanTaskFlyEnd()
          resolve(createRes.task_batch)
        } else {
          handleCancel()
          resolve('')
        }
        isTaskLoading.value = false
      },
      `${store.state.userInfo.id}/`,
      `/layout_tasks/paiban_task_data/`
    )
  })
}

/**
 * 排版设置确认（开始排版逻辑 + 埋点）
 * @returns {boolean} 校验是否通过，供 handleConfirmCreateTask 判断是否继续创建任务
 */
async function handleConfirmPaiban(event: MouseEvent, isCreateTask = false) {
  // 有对纹板件时校验对纹权限
  const hasGrainPlanks = (props.filterPlankList || [])
    .flatMap((item) => item.parts || [])
    .some(
      (part) =>
        part.textureGrainInfo && Object.keys(part.textureGrainInfo).length
    )
  if (hasGrainPlanks) {
    if (
      !checkUserPermissionsWithDetailToast([
        USER_PERMISSION_KEY.PANEL_GRAIN_ALIGN,
      ])
    )
      return
  }
  isShowExPaibanConfirm.value = false
  // 点击确定开始排版
  if (hasMissingBrandPlankInCustomOrder.value) {
    Vue.prototype.$message.error(
      translateLang('当前用料方案存在品牌小板没有可用品牌大板进行排版!')
    )
    return
  }

  if (!judgeSelectTemplate()) return
  // 校验裁剪为最大尺寸模板是否符合规则
  if (!judgeMaxRectTemplate()) return
  saveStandardPlank()
  state.isCreateTask = isCreateTask

  if (state.isSpecialShape) {
    if (radioVal.value === 'PRIMARY') {
      buryPointApi('material', 'primaryNest')
    } else {
      buryPointApi('material', 'seniorNest')
    }
  }
  if (state.isPreLayout) {
    buryPointApi('material', 'pre_layout')
  }
  if (state.isLessReverse) {
    buryPointApi('material', 'less_reverse')
  }
  if (state.surplusTailorWay == 'maxRect') {
    buryPointApi('material', 'surplus_maxRect')
    if (state.isSetCustomRect) {
      buryPointApi('material', 'set_customRect')
    }
  } else {
    buryPointApi('material', 'surplus_commonRect')
  }
  if (state.isSurNotLayoutMat) {
    buryPointApi('material', 'surplus_not_layout')
  }
  if (state.stacking_method == 'long') {
    buryPointApi('material', 'stacking_method_long')
  } else {
    buryPointApi('material', 'stacking_method_short')
  }
  emits('onConfirm', state)
}

// 保存选择的标准大板
const saveStandardPlank = () => {
  let selectStandardPlank: any = state.selectStandardPlank
  if (typeof selectStandardPlank === 'string') {
    selectStandardPlank = JSON.parse(state.selectStandardPlank)
  }

  store.commit('setSelectStandardPlank', selectStandardPlank)
  store.commit('setHistoryPlankEdgeOff', selectStandardPlank.plankEdgeOff)
}

function handleSelectProLine(proLine: any) {
  selectLine.value = proLineList.value.find((line) => line.id === proLine)
  const cuttingEquipment = selectLine.value
    ? selectLine.value.data.cuttingEquipment
    : ''

  const sawToExportPartData =
    selectLine.value.data.cuttingEquipment === 'engraving' &&
    selectLine.value.data.saw_setting.saw_enable &&
    selectLine.value.data.saw_setting.saw_aio
  if (cuttingEquipment === 'electronicSaw' || sawToExportPartData) {
    isElectron.value = true
    state.isPreLayout = false
  } else {
    isElectron.value = false
  }
  emits('onSelectProLine', selectLine.value)
}

function translateLang(key: string) {
  return translate(key)
}
function handleCancel() {
  if (props.isFromDrawAllParts) {
    if (!judgeSelectTemplate()) {
      return
    }
    // 关闭弹窗，将数据传递出去
    emits('getFinalData', JSON.parse(JSON.stringify(state)))
    // 表格数据
    if (state.surplusAutoTailor) {
      emits('getFinalTableData', JSON.parse(JSON.stringify(surplusData.value)))
      emits(
        'getFinalSurplusSelectData',
        JSON.parse(JSON.stringify(surplusSelect.value))
      )
    }
  }
  emits('onCancel')
}

function handleSendToFactory() {
  const sawToExportPartData =
    selectLine.value.data.cuttingEquipment === 'engraving' &&
    selectLine.value.data.saw_setting.saw_enable &&
    selectLine.value.data.saw_setting.saw_aio
  if (
    selectLine.value.data.cuttingEquipment === 'electronicSaw' ||
    sawToExportPartData
  ) {
    emits('onConfirmSend', '', state)
  } else {
    sendToFactoryDialog.value = true
    emits('onSendToFactory')
  }
}

function handleConfirmSend(tagTemp: any) {
  sendToFactoryDialog.value = false
  emits('onConfirmSend', tagTemp, state)
}
function handleCloseSend() {
  sendToFactoryDialog.value = false
  emits('onCloseSend')
}

// 下拉框选择
function tableSelectChange(row: any) {
  uploadOneTemp(row)
}
// 失焦
function surplusInputBlur(row: any) {
  uploadOneTemp(row)
}

// 添加余料模板
function addTemp(payload: any) {
  const { data, res } = payload
  // 添加模板后向表格数据中添加一项数据 直接在表格中加入数据会让每页条数失效
  // 需要保持数据不超过当前选择的页面条数
  surplusData.value.unshift(data)
  if (surplusData.value.length > page.limit) {
    // 删除最后一条数据
    surplusData.value.pop()
  }
  surplusData.value = surplusData.value.map((d, index) => ({ ...d, index }))
  oldSurplusData.value = JSON.parse(JSON.stringify(surplusData.value))
  // 更新总数
  pagination.total = res.data.total
}

// 某一行某个数据变化
function uploadOneTemp(row: any) {
  const d = oldSurplusData.value.filter((item) => item.id == row.id)[0]
  const flag = Object.keys(d).every((key) => {
    const dD = isNaN(d[key]) ? d[key] : +d[key]
    const rowD = isNaN(row[key]) ? row[key] : +row[key]
    return dD == rowD
  })
  // const flag =
  //   +row.width == +d.width &&
  //   +row.length == +d.length &&
  //   row.texDir == d.texDir
  if (!flag) {
    const data = JSON.parse(JSON.stringify(row))
    Reflect.deleteProperty(data, 'uniqueSign')
    Vue.prototype.$token('/save_surplus_model', data, (res: any) => {
      if (res.status == 1) {
        Vue.prototype.$message.success(translateLang('common.editSuccess'))
        // 更改成功后，更新旧的数据
        oldSurplusData.value = JSON.parse(JSON.stringify(surplusData.value))
      } else {
        // 修改失败回到第一页
        page.page = 1
        getSurplusTemp(page)
        Vue.prototype.$message.error(res.data)
      }
    })
  }
}
// 排版方案选择
function handleSelectPaibanWay(item: any) {
  switch (item) {
    case 'paiban':
      buryPointApi('material', 'paiban')
      break
    case 'paiban_v2':
      buryPointApi('material', 'paiban_v2')
      break
  }
  if (selectedPaibanWay.value.includes('blue_ai')) {
    selectedPaibanWay.value = 'paiban_v2'
  }

  let layoutMethodStr = paibanWayList.value.find(
    (e) => e.interface === selectedPaibanWay.value
  ).title

  state.paibanWay = state.isLessReverse
    ? selectedPaibanWay.value.includes('v2')
      ? selectedPaibanWay.value.replace('_v2', '_roll_v2')
      : selectedPaibanWay.value + '_roll'
    : selectedPaibanWay.value

  if (state.isLessReverse) {
    layoutMethodStr += '_少翻板'
  }
  if (state.isSpecialShape) {
    layoutMethodStr += '_计算异形'
  }

  state.layoutMethod = layoutMethodStr
}
// 处理余料不排指定小板
function handleSurNotLayout() {
  if (state.isSurNotLayoutMat) {
    // todo
  }
}

/**
 * 选择普通或高级嵌套时调用的回调函数
 * @param {RadioEventTarget} target 事件对象
 * @return
 * @author zhouchi 2024-07-17 8-06修复异形嵌套BUG
 * */
function handlerRadioOption(target: RadioEventTarget): void {
  const val = target.value as keyof typeof nestEnum
  state.nesting_version = nestEnum[val]
  // 记录选择的嵌套模式
  updateLocalPreference({
    isUseSeniorNest: val === 'SENIOR',
  } as any)
}

function handleAdvancedSettingCancel() {
  initFeatureDisplay()
  isShowAdvancedSetting.value = false
}
function handleAdvancedSettingConfirm() {
  updateLocalPreference({
    surplus_cut_smart_speed_up: advancedFeature.surplus_cut_smart_speed_up,
    featureDisplay: featureDisplay,
  } as any)
  isShowAdvancedSetting.value = false
}

/**
 * 处理高级设置选项卡切换
 * @param tab 切换后的选项卡
 */
function handleAdvancedSettingTabChange(tab: string) {
  console.log(tab)
}

/**
 * 处理余料智能提速勾选变化
 */
function handleAdvancedSettingSurplusAutoCutChange() {
  buryPointApi('material', 'advanced_setting_surplus_auto_cut')
}

// 标准大板选择
function handleSelectStandard(value: string) {
  emits('onSelectStandard', JSON.parse(value))
  Vue.set(state.plankOrderList, 0, {
    plankOrder: 1,
    plankType: '标准大板',
    matCode: '-',
    plankSize: `${JSON.parse(value).plankWidth}x${
      JSON.parse(value).plankHeight
    }`,
    plankEdgeOff: JSON.parse(value).plankEdgeOff,
    texture: '-',
    thick: '-',
    isHighPlank: '-',
    amount: 9999,
    id: genUniId(),
  })
}

function tableInputChange(row: any, prop: any) {
  // 这里的封装问题有点大的，不够灵活，后面需要改一下
  const numArr = ['width', 'lenght', 'thick']
  const oldValue = row[prop] + ''
  if (numArr.includes(prop)) {
    verifyInputNumber(row[prop], row, [prop], '5-2')
    if (prop === 'thick' && row[prop] == 0 && oldValue) {
      row[prop] = ''
    }
    if (!oldValue) {
      row[prop] = ''
    }
  }
}

// 删除余料模板
async function deleteTemp() {
  if (!surplusSelect.value.length)
    return Vue.prototype.$message.error('至少选择一项删除')
  const confirm = await Vue.prototype.$confirm(
    `是否删除这${surplusSelect.value.length}个数据模板?`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      cancelButtonClass: 'paiban_setting_cancel_delete_btn',
      confirmButtonClass: 'paiban_setting_confirm_delete_btn',
      type: 'warning',
    }
  )
  if (confirm == 'cancel') return
  let model_ids = [] as any[]
  surplusSelect.value.map((item) => {
    model_ids.push(item.id)
  })
  Vue.prototype.$token('/delete_surplus_model', { model_ids }, (res: any) => {
    if (res.status != 1) {
      Vue.prototype.$message.error(res.msg)
    } else {
      Vue.prototype.$message.success('删除成功')
      // 判断当前页面上是否还有数据，如果数据全部被删除了，需要判断展示哪一页的数据
      if (surplusData.value.length === surplusSelect.value.length) {
        // 如果当前页是第一页
        if (page.page !== 1) {
          page.page--
        }
      }
      getSurplusTemp(page)
      deleteIdList.value = model_ids
    }
  })
}

function getSurplusTemp(p: any) {
  tableLoading.value = true

  Vue.prototype.$token('/surplus_model_list', p, (res: any) => {
    if (res.status === 1) {
      surplusData.value = res.data.data.map((d: any, index: number) => ({
        ...d,
        index,
      }))
      oldSurplusData.value = JSON.parse(JSON.stringify(surplusData.value))
      pagination.total = res.data.total
    } else {
      Vue.prototype.$message.error(res.status)
    }
    tableLoading.value = false
  })
}

// 余料表格单选/多选
function selectChange(select: any) {
  // surplusSelect.value 余料选择的数据
  surplusSelect.value = select
}
// 页面切换发起请求
function pageChange(p: any) {
  page.limit = p.limit
  page.page = p.page
  getSurplusTemp(page)
  // 页面切换发起请求，清空数据
  // surplusSelect.value = []
}
// 显示未排小板清单
function handleShowPartDetail() {
  emits('onShowPartDetail')
}
// 下料数量输入检测
function handleCheckInput(row: any) {
  row.amount = row.amount.replace(/[^\d]/g, '').slice(0, 4)
  // 限制第一位不为0
  if (row.amount.charAt(0) == '0') {
    row.amount = row.amount.slice(1, 4)
  }
}
// 下料数量失焦
function handleBlur(row: any) {
  if (row.amount == '') {
    row.amount = 0
  }
}
// 删除自定义大板
function handleDelPlankOrder(row: any, rowIndex: number) {
  state.plankOrderList.splice(rowIndex, 1)
  state.plankOrderList = state.plankOrderList.map(
    (item: any, index: number) => ({ ...item, plankOrder: index + 1 })
  )
}
// 自定义大板排版行拖拽
function handleDropPlankOrder() {
  const tbody = document.querySelector(
    '.plank-order-table .el-table__body-wrapper tbody'
  )
  Sortable.create(tbody as HTMLElement, {
    disabled: false,
    handle: '.drag-btn', // 指定拖动的按钮类名
    onEnd({ newIndex, oldIndex }) {
      const currentRow = state.plankOrderList.splice(oldIndex, 1)[0]
      state.plankOrderList.splice(newIndex, 0, currentRow)
      state.plankOrderList = state.plankOrderList.map(
        (item: any, index: number) => ({ ...item, plankOrder: index + 1 })
      )
    },
  })
}
// 一键最大下料数量
function handleMaxAmount(row: any) {
  row.amount = 9999
}
function handleTranslateCustomTable() {
  // 给element表格表头添加title
  const theadCell = document.querySelectorAll(
    '.plank-order-table .el-table__header-wrapper .cell'
  )
  theadCell.forEach((item, index) => {
    item.setAttribute(
      'title',
      translateLang(state.plankOrderColumns[index].transKey)
    )
  })
}

function initFeatureDisplay() {
  Object.assign(
    featureDisplay,
    store.state.preferencesSetting?.setting.featureDisplay ?? {
      preLayout: true,
      paibanWay: true,
      specialShape: true,
      standardPlank: true,
      autoSelectBigPlank: true,
      customPlankOrder: true,
      surplusAutoTailor: true,
      combineToLShape: true,
    }
  )
  advancedFeature.surplus_cut_smart_speed_up =
    store.state.preferencesSetting?.setting?.surplus_cut_smart_speed_up ?? false
}

/**
 * @description 本页面用于更新偏好设置，会在偏好设置更新以及页面加载时调用
 * @param data 不传值则是 store 中的偏好设置
 */
function updatePreference({ data, isErr }: any) {
  if (isErr) return
  data = data || store.state.preferencesSetting?.setting
  state.isSurplusNoRoll = data.surplus_no_roll
  state.surplusAutoTailor = data.surplusAutoTailor
  state.surplusTailorWay = data.surplusTailorWay
  state.shortSideRect = data.shortSideRect || 250
  state.longSideRect = data.longSideRect || 300
  state.isSetCustomRect = data.isSetCustomRect ?? false
  state.customRectTemplate = cloneDeep(
    data.customRectTemplate || [
      {
        shortSideRect: 250,
        longSideRect: 300,
        thickRect: null,
      },
    ]
  )
  state.isCombineToLShape = data.isCombineToLShape ?? false
  state.process_line_id = data.process_line_id
  state.nesting_version =
    data.nesting_version === 2 && hasAdvancedNestPermission.value
      ? nestEnum.SENIOR
      : nestEnum.PRIMARY
  state.isSurNotLayout = data.isSurNotLayout ?? false
  state.plankNames = data.plankNames ?? []
  state.stacking_method = data.stacking_method
  advancedFeature.surplus_cut_smart_speed_up =
    data.surplus_cut_smart_speed_up ?? false
  Object.assign(featureDisplay, data.featureDisplay ?? {})
  store.commit('setSurplusAutoTailor', state.surplusAutoTailor)
  store.commit('setSurplusNoRoll', state.isSurplusNoRoll)
  store.commit('setIsCombineToLShape', state.isCombineToLShape)
  // 本地参数特殊化的处理
  radioVal.value =
    data.nesting_version === 2 && hasAdvancedNestPermission.value
      ? 'SENIOR'
      : 'PRIMARY'
  let params: any = {}
  if (window.sessionStorage.getItem('thinkerx_material')) {
    params.production_from = 'guimen'
  }
  params.platform = store.state.userInfo.platform
  Vue.prototype.$getByToken(
    '/get_production_line_setting',
    params,
    async (resc: any) => {
      isLoading.value = false
      if (resc.status == 1) {
        proLineList.value = resc.data
        store.commit('setProLineList', proLineList.value)
        emits('onFetchProLineList', resc.data)
        const currentLine = resc.data.find(
          (line: any) => data.process_line_id === line.id
        )
        selectLine.value = currentLine ? currentLine : resc.data[0]
        emits('onSelectLine', selectLine.value)
        state.process_line_id = selectLine.value.id
        const productEquip = selectLine.value.data.cuttingEquipment
        const isSawToExportPartData =
          selectLine.value.data.cuttingEquipment === 'engraving' &&
          selectLine.value.data.saw_setting.saw_enable &&
          selectLine.value.data.saw_setting.saw_aio
        if (productEquip === 'electronicSaw' || isSawToExportPartData)
          isElectron.value = true
        if (productEquip === 'glassEquip') {
          isGlassEquip.value = true
          state.paibanWay = 'paiban'
          state.isLessReverse = false
          state.isSpecialShape = false
          state.layoutMethod = '锯切排版'
          selectedPaibanWay.value = 'paiban'
        } else {
          isGlassEquip.value = false
          state.isLessReverse = data.isLessReverse
          state.isSpecialShape = data.isSpecialShape
          selectedPaibanWay.value = data.paibanWay
            ? data.paibanWay.replace('_roll', '')
            : 'paiban_v2'
          state.isSurNotLayoutMat = data.isSurNotLayoutMat ?? true
          handleSelectPaibanWay(selectedPaibanWay.value)
        }
        data.surplusAutoTailor && getSurplusTemp(page)
        emits('getInitData', JSON.parse(JSON.stringify(state)))
        if (state.surplusAutoTailor) {
          setTimeout(() => {
            emits(
              'getInitTableData',
              JSON.parse(JSON.stringify(surplusData.value))
            )
            // 获取选择的数据项，查看数据是否改变
            emits(
              'getInitSurplusSelectData',
              JSON.parse(JSON.stringify(surplusSelect.value))
            )
          }, 200)
        }
      }
    }
  )
}

// 处理特殊大板表格修边值显示
function handleShowTrimEdge(trimEdge: string) {
  if (trimEdge.toString().includes(',')) {
    const trimEdgeArr = trimEdge.split(',')
    return `${translateLang('basePlankManager.front')}${
      trimEdgeArr[0]
    }-${translateLang('basePlankManager.back')}${
      trimEdgeArr[1]
    }-${translateLang('basePlankManager.left')}${
      trimEdgeArr[2]
    }-${translateLang('basePlankManager.right')}${trimEdgeArr[3]}`
  } else {
    return trimEdge
  }
}

/** @description 更改原片设置 */
function handleChangeOriginPlankSetting(key: string) {
  // 如果自动选用特殊大板为false，则只排超尺小板设置为false
  if (key === 'isAutoSelected' && !state.materialRes.isAutoSelected) {
    state.materialRes.only_layout_too_big = false
  }
  fetchSaveBaseMaterial({
    uid: store.state.userInfo.id,
    data: {
      only_layout_too_big: state.materialRes.only_layout_too_big,
      isAutoSelected: state.materialRes.isAutoSelected,
    },
  })
}

/**
 * @description 添加事件监听
 */
function addBusEvent() {
  EventBus.$on(EventBusKey.TRANSLATE, handleTranslateCustomTable)
}

/**
 * @description 取消事件监听
 */
function removeBusEvent() {
  EventBus.$off(EventBusKey.TRANSLATE, handleTranslateCustomTable)
}

onMounted(async () => {
  // 挂载偏好设置的更新
  proxy.$preference.init(updatePreference, proxy.$route.path)
  addBusEvent()
  let params: any = {}
  if (window.sessionStorage.getItem('thinkerx_material')) {
    params.production_from = 'guimen'
  }
  params.platform = store.state.userInfo.platform
  isLoading.value = true
  const materialRes = await loadFullPlankManageData({
    uid: store.state.userInfo.id,
    ...params,
  })
  state.materialRes = JSON.parse(JSON.stringify(materialRes.data))
  const defaultPlank = materialRes.data.defaultPlankInfo
  let defaultSelectedPlank
  if (Array.isArray(defaultPlank)) {
    state.standardPlankList = defaultPlank
    defaultSelectedPlank = defaultPlank.find(
      (item: any) => item.default_selected
    )
  } else {
    state.standardPlankList = [defaultPlank]
    defaultSelectedPlank = defaultPlank
  }
  state.standardPlankList = state.standardPlankList.map((item: any) => ({
    ...item,
    value: JSON.stringify(item),
  }))

  state.selectStandardPlank = JSON.stringify(defaultSelectedPlank)
  store.commit('setDefaultSelectedPlank', defaultSelectedPlank)
})
onUnmounted(() => {
  removeBusEvent()
})

// 开启余料自动裁剪再调用余料常用模板接口
function handleSwitchChange(checked: boolean) {
  checked && getSurplusTemp(page)
}

function numberCheck(val: string, obj: any, prop: any) {
  verifyInputNumber(val, obj, prop, '4')
}

/** 裁剪最小尺寸新增大板厚度--删除 */
function handleDeleteRule(index: number) {
  // 必须保留一个
  if (state.customRectTemplate.length <= 1) {
    return Vue.prototype.$message.error(translateUniform('至少保留一项!'))
  }
  state.customRectTemplate.splice(index, 1)
}
/** 裁剪最小尺寸新增大板厚度--添加 */
function handleAddRule() {
  if (state.customRectTemplate.length >= 5) {
    return Vue.prototype.$message.error(translateUniform('最多添加五个!'))
  }
  state.customRectTemplate.push({
    shortSideRect: null,
    longSideRect: null,
    thickRect: null,
  })
}
const isShowThickWarning = (thick: number | null) => {
  const re = state.customRectTemplate.filter((item) => item.thickRect === thick)
  return re.length > 1
}
function inputCheckNumber($event: any, template: any, prop: string) {
  // 只能输入数字和小数点
  const targetValue = $event
  // 使用正则表达式过滤非法字符 最多输入5个数字
  const validValue = targetValue.match(/^\d{0,5}(\.\d{0,3})?/)?.[0] || ''
  // 更新输入框的值，只保留合法部分 这里这样修改会把18.这种特殊的字符串变成18，导致无法存储小数点
  // template[prop] = Number(validValue)
  template[prop] = validValue.endsWith('.') ? validValue : Number(validValue)
}
function inputBlurNumber($event: any, template: any, prop: string) {
  template[prop] = Number(template[prop])
}
function translateUniform(key: any) {
  return translateU(key)
}

expose({
  createPaibanTask,
})

return { __sfc: true,proxy, nestEnum, props, emits, saveTableData, isShowExPaibanConfirm, isShow, surplusSelect, proLineList, isLoading, tableLoading, surplusData, oldSurplusData, deleteIdList, radioVal, hasAdvancedNestPermission, hasDeepSearchPermission, dialogStyle, pagination, page, surplusVisible, state, isNoCreateTask, customPlankOrderColumns, selectedBrandPartsForCustomOrder, hasMissingBrandPlankInCustomOrder, paibanWayList, selectedPaibanWay, isShowPaibanWayToast, isTaskLoading, sendToFactoryDialog, isGlassEquip, isElectron, selectLine, isShowAdvancedSetting, isSlideAnimating, SLIDE_DURATION, advancedSettingTab, advancedFeature, featureDisplay, isWebToQt, handleAdvancedSetting, judgeSelectTemplate, judgeMaxRectTemplate, handleConfirm, handleCancelConfirm, handleConfirmCreateTask, waitPaibanTaskFlyEnd, createPaibanTask, handleConfirmPaiban, saveStandardPlank, handleSelectProLine, translateLang, handleCancel, handleSendToFactory, handleConfirmSend, handleCloseSend, tableSelectChange, surplusInputBlur, addTemp, uploadOneTemp, handleSelectPaibanWay, handleSurNotLayout, handlerRadioOption, handleAdvancedSettingCancel, handleAdvancedSettingConfirm, handleAdvancedSettingTabChange, handleAdvancedSettingSurplusAutoCutChange, handleSelectStandard, tableInputChange, deleteTemp, getSurplusTemp, selectChange, pageChange, handleShowPartDetail, handleCheckInput, handleBlur, handleDelPlankOrder, handleDropPlankOrder, handleMaxAmount, handleTranslateCustomTable, initFeatureDisplay, updatePreference, handleShowTrimEdge, handleChangeOriginPlankSetting, addBusEvent, removeBusEvent, handleSwitchChange, numberCheck, handleDeleteRule, handleAddRule, isShowThickWarning, inputCheckNumber, inputBlurNumber, translateUniform, addSurplus, drawSupplus, gBaseModal, GPaidFeature, NewContent, pageTable, USER_PERMISSION_KEY, matchHighlightBoardName, MDeepBadgeAurora, sendModal, rules, surPlusConfig }
}

})